<template>
    <div>
        <div
            class="py-10 px-5 md:px-3 xl:px-0"
            :class="backgroundColorMapper(employeeEducationSectionColor.value)"
            @mouseover="hasManualInput = true"
            @mouseleave="hasManualInput = false"
        >
            <div class="container">
                <div class="w-full xl:w-10/12 mx-auto">
                    <h2
                        class="font-heading text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-10 text-center uppercase"
                        :class="employeeEducationSectionColor.value === 'yellow' ? 'text-black' : 'text-white'"
                        v-text="employeeEducationSectionTitle"
                    ></h2>
                    <div class="relative z-0 flex w-full items-center justify-between">
                        <div class="absolute left-2 right-2 mx-auto h-2 bg-white md:left-20 md:right-20 md:-mt-5">
                            <div
                                class="absolute left-0 h-full w-0 transition-all duration-500 ease-out"
                                :class="[
                                    employeeEducationSectionColor.value === 'orange' ? 'bg-teal' : '',
                                    employeeEducationSectionColor.value === 'orange' ? 'bg-teal' : '',
                                    employeeEducationSectionColor.value === 'orange-600' ? 'bg-teal' : '',
                                    employeeEducationSectionColor.value === 'teal' ? 'bg-orange' : '',
                                    employeeEducationSectionColor.value === 'teal-600' ? 'bg-orange' : '',
                                    employeeEducationSectionColor.value === 'blue' ? 'bg-orange' : '',
                                    employeeEducationSectionColor.value === 'blue-600' ? 'bg-orange' : '',
                                    employeeEducationSectionColor.value === 'yellow' ? 'bg-purple' : '',
                                    employeeEducationSectionColor.value === 'purple' ? 'bg-yellow' : '',
                                ]"
                                :style="'width:' + stepperProgress"
                            ></div>
                        </div>

                        <div
                            v-for="(step, stepIndex) in employeeEducationSteps"
                            :key="stepIndex"
                            class="flex flex-col items-center transition-all duration-500 ease-out hover:cursor-pointer"
                            :class="[
                                employeeEducationSectionColor.value === 'orange' ? 'text-teal' : '',
                                employeeEducationSectionColor.value === 'orange' ? 'text-teal' : '',
                                employeeEducationSectionColor.value === 'orange-600' ? 'text-teal' : '',
                                employeeEducationSectionColor.value === 'teal' ? 'text-orange' : '',
                                employeeEducationSectionColor.value === 'teal-600' ? 'text-orange' : '',
                                employeeEducationSectionColor.value === 'blue' ? 'text-orange' : '',
                                employeeEducationSectionColor.value === 'blue-600' ? 'text-orange' : '',
                                employeeEducationSectionColor.value === 'yellow' ? 'text-purple' : '',
                                employeeEducationSectionColor.value === 'purple' ? 'text-yellow' : '',
                            ]"
                            @click="employeeEducationStepOnClick(stepIndex)"
                        >
                            <div
                                class="relative grid aspect-square h-16 w-16 transition-all duration-500 ease-out place-items-center rounded-full border-2 bg-white shadow-topanimation md:h-20 md:w-20 md:border-4 lg:h-24 lg:w-24"
                                :class="[
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'orange'
                                        ? 'border-teal bg-white text-teal'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex &&
                                    employeeEducationSectionColor.value === 'orange-600'
                                        ? 'border-teal bg-white text-teal'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'teal'
                                        ? 'border-orange bg-white text-orange'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'teal-600'
                                        ? 'border-orange bg-white text-orange'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'blue'
                                        ? 'border-orange bg-white text-orange'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'blue-600'
                                        ? 'border-orange bg-white text-orange'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'yellow'
                                        ? 'border-purple bg-white text-purple'
                                        : 'border-white',
                                    currentStepIndex >= stepIndex && employeeEducationSectionColor.value === 'purple'
                                        ? 'border-yellow bg-white text-yellow'
                                        : 'border-white',
                                ]"
                            >
                                <i
                                    class="text-3xl md:text-4xl fa-light"
                                    :class="[
                                        currentStepIndex >= stepIndex ? 'opacity-100' : 'opacity-50',
                                        `fa-${step.employee_education_step_icon.key}`,
                                        employeeEducationSectionColor.value === 'orange' ? 'text-teal' : '',
                                        employeeEducationSectionColor.value === 'orange' ? 'text-teal' : '',
                                        employeeEducationSectionColor.value === 'orange-600' ? 'text-teal' : '',
                                        employeeEducationSectionColor.value === 'teal' ? 'text-orange' : '',
                                        employeeEducationSectionColor.value === 'teal-600' ? 'text-orange' : '',
                                        employeeEducationSectionColor.value === 'blue' ? 'text-orange' : '',
                                        employeeEducationSectionColor.value === 'blue-600' ? 'text-orange' : '',
                                        employeeEducationSectionColor.value === 'yellow' ? 'text-purple' : '',
                                        employeeEducationSectionColor.value === 'purple' ? 'text-yellow' : '',
                                    ]"
                                ></i>
                            </div>
                            <span
                                class="hidden font-heading text-lg md:block uppercase"
                                :class="employeeEducationSectionColor.value === 'yellow' ? 'text-black' : 'text-white'"
                                v-text="step.employee_education_step_title"
                            >
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="lg:relative flex flex-col" :class="`bg-${employeeEducationSectionColor.value}`">
            <div
                class="relative w-full md:hidden lg:block lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2 lg:h-full order-2 lg:order-1 aspect-square"
            >
                <img
                    v-if="currentStep.employee_education_step_image"
                    class="w-full h-full object-cover"
                    :src="currentStep.employee_education_step_image.permalink"
                    :alt="currentStep.employee_education_step_title"
                />
            </div>
            <div
                class="xl:container relative order-1 md:order-2"
                @mouseover="hasManualInput = true"
                @mouseleave="hasManualInput = false"
            >
                <div class="mx-auto w-full xl:w-10/12 text-center lg:text-left">
                    <div
                        class="px-4 lg:w-1/2 sm:px-8 xl:pr-16 ml-auto xl:max-w-xl py-5 md:py-12 lg:py-20 xl:py-48 h-auto lg:h-[30rem] xl:h-[40rem] flex items-center justify-center"
                    >
                        <div>
                            <h4
                                class="font-heading text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-5 text-center uppercase"
                                :class="employeeEducationSectionColor.value === 'yellow' ? 'text-black' : 'text-white'"
                                v-text="currentStep.employee_education_step_title"
                            ></h4>
                            <p
                                class="mb-10 max-w-md text-center prose mx-auto"
                                :class="employeeEducationSectionColor.value === 'yellow' ? 'text-black' : 'text-white'"
                                v-text="currentStep.employee_education_step_text"
                            ></p>
                            <a
                                v-if="currentStep.employee_education_step_activate_button"
                                :href="currentStep.employee_education_step_button_link"
                                :title="currentStep.employee_education_step_button_text"
                                class="px-5 py-2 flex items-center border flex-grow-0 space-x-3 font-bold max-w-max transition duration-300 ease-in-out mx-auto cursor-pointer focus:ring-2 focus:ring-teal-600 active:ring-2 active:ring-teal-600"
                                :class="buttonColorMapper(currentStep.employee_education_step_button_color.value)"
                            >
                                <span
                                    class="md:text-lg"
                                    v-text="currentStep.employee_education_step_button_text"
                                ></span>
                                <i
                                    v-if="currentStep.employee_education_step_button_icon"
                                    class="fa-light"
                                    :class="[`fa-${currentStep.employee_education_step_button_icon.value}`]"
                                ></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { backgroundColorMapper, buttonColorMapper } from "@/helpers/colorHelper";

const props = defineProps({
    employeeEducationSectionTitle: {
        type: String,
        required: true,
    },
    employeeEducationSectionColor: {
        type: String,
        required: true,
    },
    employeeEducationSteps: {
        type: Array,
        required: true,
    },
});

const currentStepIndex = ref(0);
const hasManualInput = ref(false);
const currentStep = computed(() => props.employeeEducationSteps[currentStepIndex.value]);

const milliSeconds = 10000;

const loopThroughUsps = () => {
    setTimeout(() => {
        if (!hasManualInput.value && props.employeeEducationSteps) {
            const maxLength = props.employeeEducationSteps.length - 1;

            if (currentStepIndex.value < maxLength) {
                currentStepIndex.value += 1;
            } else {
                currentStepIndex.value = 0;
            }
        }

        loopThroughUsps();
    }, milliSeconds);
};

const employeeEducationStepOnClick = (stepIndex) => {
    currentStepIndex.value = stepIndex;
};

setTimeout(() => {
    loopThroughUsps();
}, milliSeconds);

const stepperProgress = computed(
    () => `${(100 / (props.employeeEducationSteps.length - 1)) * currentStepIndex.value}%`
);
</script>
